<template>
  <div>
    <el-date-picker v-model="localValue" :type="type" clearable :value-format="format" :picker-options="options"
      :range-separator="$t('placeHolder.to')" :start-placeholder="placeholderspan + $t('placeHolder.start')"
      :end-placeholder="placeholderspan + $t('placeHolder.end')" size="mini" v-on="$listeners"
      style="height: 100%;"></el-date-picker>
  </div>
</template>

<script>
import { switchTime } from "@/utils/methods";

export default {
  name: "Y-date",
  props: {
    placeholder: String,
    format: String,
    type: {
      type: String,
      default: "daterange",
    },
    value: {
      type: [String, Array],
      default: "",
    },
  },
  data() {
    return {
      placeholderspan: ""
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },
    options() {
      return {
        onPick: ({ maxDate, minDate }) => {
          if (maxDate && minDate) {
            if (this.type === "daterange") {
              const _maxDate = switchTime(new Date(maxDate).getTime());
              const _minDate = switchTime(new Date(minDate).getTime());
              this.$emit("update:value", [_minDate, _maxDate]);
            }
          }
        },
        handleClear: () => {
          this.$emit("update:value", []);
        },
      };
    }
  },
  created() {
    this.placeholderspan = this.placeholder
      ? this.placeholder
      : this.$t('homeSet.inputPlaceHolder');
  },
  methods: {
    datechange(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.$emit('mounted')
  }
};
</script>

<style scoped lang='scss'>
/deep/.el-range-separator {
  display: flex;
  align-items: center;
}
</style>